import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=073c87de&"
import script from "./Campaigns.vue?vue&type=script&lang=js&"
export * from "./Campaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073c87de')) {
      api.createRecord('073c87de', component.options)
    } else {
      api.reload('073c87de', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=073c87de&", function () {
      api.rerender('073c87de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Campaigns/Campaigns.vue"
export default component.exports